import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'BalooBhaijaan';
    font-weight: 400 800;
    font-style: normal;
    font-display: swap;
    src: local(※), url(resource/font/BalooBhaijaan.ttf) format('truetype');
  }

  /* Common Settings */
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    background-repeat: no-repeat;
  }
  
  /* Based on screen size: 1920*1080 */
  html, body {
    overflow: hidden;
    width: 100%;
    min-width: 100%;
    height: 100%;
    font-family: 'BalooBhaijaan';
  }

  body {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  ul, ol {
    list-style: none;
  }

  a {
    color: unset;
    text-decoration: none;
  }

  img {
    border: none;
  }

  button {
    appearance: none;
    background-color: initial;
    border: none;
    outline: unset;
    box-shadow: none;
    color: inherit;
    text-decoration: none;
    cursor: pointer;
  }

  input {
    appearance: none;
    border: none;
    background-color: transparent;
  }

  input:focus {
    outline-color: #333
  }

  ::-webkit-scrollbar {
    width: 8.000006px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #a8a8a8;
  }

  ::-webkit-scrollbar-track {
    background-color: transparent;
  }

  /* Based on screen size: 1920*1080 */
  .wrap {
    width: 100vw;
    height: 1080px;
  }

  main {
    width: 100%;
    height: 100%;
  }
`;